var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"mx-auto",attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"text-h4 font-weight-medium pb-1"},[_vm._v(" Page not found! ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }